import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import styles from './footer.module.scss';

export const ALIGN_ITEMS_DEFAULT = 'center';
export const GAP_DEFAULT = '8px';
export const JUSTIFY_CONTENT_DEFAULT = 'flex-end';

export default class SpdsModalStandardFooter extends Super {
  baseClass = 'spds-modal-standard-footer';
  styles = styles;

  get gap() {
    return this.args.gap ?? GAP_DEFAULT;
  }

  get alignItems() {
    return this.args.alignItems ?? ALIGN_ITEMS_DEFAULT;
  }

  get justifyContent() {
    return this.args.justifyContent ?? JUSTIFY_CONTENT_DEFAULT;
  }

  <template>
    <FlexRow
      @alignItems={{this.alignItems}}
      @gap={{this.gap}}
      @justifyContent={{this.justifyContent}}
      @tag="footer"
      class={{this.classes}}
      data-test-spds-modal-standard-footer
      id={{this.id}}
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}
